import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1a7310ee"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-opacity": "1",
  d: "M0,160L48,138.7C96,117,192,75,288,90.7C384,107,480,181,576,213.3C672,245,768,235,864,224C960,213,1056,203,1152,213.3C1248,224,1344,256,1392,272L1440,288L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
}, null, -1));

const _hoisted_2 = [_hoisted_1];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["background-wave", `wave-${_ctx.$route.name}`]),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 300"
  }, _hoisted_2, 2);
}